export default __webpack_public_path__ + "static/media/bg-new2.31d1875f.jpg";